import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DashboardSectionComponent} from './dashboard-section.component';
import {DxToolbarModule} from 'devextreme-angular';


@NgModule({
  declarations: [DashboardSectionComponent],
  imports: [
    CommonModule,
    DxToolbarModule
  ],
  exports: [DashboardSectionComponent]
})
export class DashboardSectionModule {
}
